export default "__VITE_ASSET__BnQIfkiu__"